module.exports = __webpack_public_path__ + "static/main-header-5d1cbd9a834ece77f46d12bd623fe4fc.jpg";